import { MGM_EXIT_REFERRED_BOOKER_FLOW } from './actionTypes';

export const exitReferredBookerFlowAction = () => async (dispatch, getState) => {
  const { isReferredBooker } = getState().mgm;
  // No need to do anything if ReferredBooker flow is already turned off
  if (!isReferredBooker) {
    return;
  }

  dispatch({ type: MGM_EXIT_REFERRED_BOOKER_FLOW });
};
